<script setup></script>

<template>
  <!-- flex и items-center отцентрируют внутренний блок по вертикали -->
  <div class="flex items-center w-full min-h-svh bg-blueice">
    <div class="absolute z-1 inset-x-0 -bottom-23">
      <!-- prettier-ignore   -->
      <img src="../../public/svg/soil_bg.svg" class="
      h-auto w-full">
    </div>
    <!-- prettier-ignore   -->
    <div class="absolute z-1 top-[15%] left-[5%] w-[15%] 
    max-w-[200px] min-w-[100px]">
      <!-- prettier-ignore   -->
      <img src="../../public/svg/noto_cloud.svg" class="
      h-auto w-full">
    </div>
    <!-- prettier-ignore   -->
    <div class="absolute z-1 top-[25%] right-[15%] w-[15%] 
    max-w-[200px] min-w-[100px]">
      <!-- prettier-ignore   -->
      <img src="../../public/svg/noto-v1_cloud.svg" class="
      h-auto w-full">
    </div>
    <!-- prettier-ignore   -->
    <div class="absolute z-1 left-[5%] w-[15%] max-w-[200px] min-w-[100px] bottom-[15%]">
      <!-- prettier-ignore   -->
      <img src="../../public/svg/noto_deciduous-tree.svg" class="
      h-auto w-full">
    </div>
    <!-- prettier-ignore   -->
    <div class="absolute z-1 right-[16%] w-[15%] max-w-[200px] min-w-[100px] bottom-[3%]">
      <!-- prettier-ignore   -->
      <img src="../../public/svg/noto_deciduous-tree.svg" class="
      h-auto w-full">
    </div>
    <!-- prettier-ignore   -->
    <div class="absolute z-1 right-[4%] w-[15%] max-w-[200px] min-w-[100px] bottom-[14%]">
      <!-- prettier-ignore   -->
      <img src="../../public/svg/pine.svg" class="
      h-auto w-full">
    </div>
    <!-- prettier-ignore   -->
    <div class="absolute z-1 left-[20%] w-[15%] max-w-[200px] min-w-[100px] bottom-[1%]">
      <!-- prettier-ignore   -->
      <img src="../../public/svg/twemoji_deciduous-tree.svg" class="
      h-auto w-full">
    </div>
    <!-- Обертка .wrapper (макс. ширина 1635px, по центру, с адаптивными боковыми отступами) -->
    <div class="w-full max-w-[1635px] mx-auto px-4 sm:px-8 lg:px-16 h-full">
      <!-- clamp(минимальный_размер, желаемый_размер(vw), максимальный_размер) - текст будет плавно расти -->
      <!-- prettier-ignore   -->
      <div class="-mt-62 text-white font-bold text-[clamp(2rem,5vw,48px)] leading-tight text-center md:text-left">
        <h2 class="mb-2 text-center">Найди новую</h2>
        <h2 class="text-center">Профессию в HandBox</h2>
        <div class="text-white font-standart text-center md:text-center mt-10 
        grid grid-cols-3 gap-4 text-xl md:text-2xl lg:text-3xl xl:text-4xl">
          <h3>HandBox №1</h3>
          <h3>100 000+</h3>
          <h3>300+</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
